import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Avatar from '../Avatar/Avatar';

const CONTAINER_SIZE = 40;

const LAYOUTS = {
  1: {
    bubbleSize: CONTAINER_SIZE,
    fontSize: 16,
    positions: [{ top: 0, left: 0 }],
  },
  2: {
    bubbleSize: 26,
    fontSize: 10,
    positions: [
      { top: -2, left: -2 },
      { top: 16, left: 16 },
    ],
  },
  3: {
    bubbleSize: 22,
    fontSize: 9,
    positions: [
      { top: -2, left: 9 },
      { top: 16, left: -2 },
      { top: 16, left: 20 },
    ],
  },
};

const Container = styled('div')`
  width: ${CONTAINER_SIZE}px;
  height: ${CONTAINER_SIZE}px;
  min-width: ${CONTAINER_SIZE}px;
  position: relative;
  flex-shrink: 0;
`;

const BubbleWrapper = styled('div')`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
`;

const OverflowBubble = styled('div')`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background: #6C5CE7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Nunito Sans';
  font-weight: 700;
  font-size: ${(props) => props.fontSize}px;
  color: #ffffff;
`;

const getMemberFullName = (member) => [member.primaryName, member.secondaryName].filter(Boolean).join(' ');

const AvatarGroup = ({ members }) => {
  if (!members || members.length === 0) return null;

  const count = members.length;

  if (count === 1) {
    const member = members[0];
    return (
      <Avatar
        avatar={member.imageUrl || null}
        name={getMemberFullName(member)}
        linearGradient={member.gradientColors}
        size={CONTAINER_SIZE}
        fontSize={16}
      />
    );
  }

  const layout = count <= 3 ? LAYOUTS[count] : LAYOUTS[3];
  const visibleCount = count <= 3 ? count : 2;
  const showOverflow = count > 3;

  return (
    <Container>
      {members.slice(0, visibleCount).map((member, index) => (
        <BubbleWrapper
          key={member.id || index}
          top={layout.positions[index].top}
          left={layout.positions[index].left}
        >
          <Avatar
            avatar={member.imageUrl || null}
            name={getMemberFullName(member)}
            linearGradient={member.gradientColors}
            size={layout.bubbleSize}
            fontSize={layout.fontSize}
          />
        </BubbleWrapper>
      ))}
      {showOverflow && (
        <BubbleWrapper
          top={layout.positions[2].top}
          left={layout.positions[2].left}
        >
          <OverflowBubble size={layout.bubbleSize} fontSize={layout.fontSize}>
            +{count - 2}
          </OverflowBubble>
        </BubbleWrapper>
      )}
    </Container>
  );
};

AvatarGroup.propTypes = {
  members: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    primaryName: PropTypes.string,
    secondaryName: PropTypes.string,
    imageUrl: PropTypes.string,
    gradientColors: PropTypes.arrayOf(PropTypes.string),
  })),
};

AvatarGroup.defaultProps = {
  members: [],
};

export default AvatarGroup;
